import * as fs from "fs";
import * as ko from "knockout";
import { RNSAPI } from "../../api";
import { MainViewModel } from "../../main";
import '../dataTable/dataTable';

export class InboxOverviewViewModel {
    inboxes = ko.observableArray([]);

    async loadInboxes() {
        let inboxes = await RNSAPI.getAllInboxes();
        this.inboxes(inboxes.Payload.Accounts.map((inbox) => {
            inbox.actionHandlers = [{
                icon: "pencil",
                name: "Edit",
                action: () => MainViewModel.RoutingTable.showInboxView({ id: inbox.EMailAccount_ID })
            }, {
                icon: "trash-o",
                name: "Löschen",
                action: async () => {
                    await RNSAPI.deleteInboxById(inbox.EMailAccount_ID);
                    this.loadInboxes();
                }
            }];
            return inbox;
        }));
    }

    constructor() {
        this.loadInboxes();
    }
}

let html = fs.readFileSync(__dirname + '/inboxoverview.html', 'utf8');

ko.components.register("inboxoverview-view", {
    viewModel: InboxOverviewViewModel,
    template: html
});